export default __webpack_public_path__ + "332e857da70f4acf53ccfd91bea47456.svg";